// 

// app/onboarding.tsx
import { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Image,
} from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { FontAwesome, FontAwesome5 } from '@expo/vector-icons';
import colors from '../config/colors';
import textStyles from '../config/textStyles';
import defaultStyles from '../config/styles';
import Button from '../components/Button';
import { useNavigation } from '@react-navigation/native'; // esto te sirve para navegar en el ambiente donde invocaste este componente
import routes from '../navigation/routes';
import Ionicons from '@expo/vector-icons/Ionicons';

const SLIDES = [
  {
    icon: 'Dichapp',
    title: 'Bienvenido a Dichapp',
    description:
      'Somos una red social que busca crear acciones que cambien de manera positiva el mundo en el que vivimos como seres humanos, mejorando nuestro entorno y convivencia para generar acciones inteligentes y creativas para distintos escenarios de nuestra vida cotidiana.',
    color: colors.aguacateGreen,
  },
  {
    icon: '🌍🌎🌏', //'💬',
    title: 'Comparte lo que importa',
    description:
      'Publica, comenta y conecta con personas que comparten tus intereses en tiempo real. '+
      'Crea un impacto positivo en tu comunidad y en el mundo a través de tu participación en acciones, ideas y proyectos.',
    color: colors.green,
  },
  {
    icon: 'seedling',
    title: 'Una comunidad local - global',
    description:
      'Sumate a nuesta comunidad y siembra semillas de cambio para todos.',
     // 'Más de 2 millones de personas ya forman parte. Encuentra tu tribu y hazla crecer.',
    color: colors.lemonGreen,
  },
];

export default function OnboardingScreen() {
  const [index, setIndex] = useState(0);
  const [done, setDone] = useState(false);

  const slide = SLIDES[index];
  const isLast = index === SLIDES.length - 1;
  const navigation = useNavigation()

  const next = () => {
    if (isLast) {
      setDone(true); // aquí en el futuro navegas a /register
    } else {
      setIndex(index + 1);
    }
  };

  const skip = () => setDone(true); // aquí navegas a /login
  const skipBack = () => navigation.navigate(routes.FEED_SCREEN); // aquí navegas a /login

  // Pantalla final (placeholder, aquí pondrías tu login o registro)
  if (done) {
    return (
      <View style={styles.doneContainer}>
        <Text style={styles.doneText}>¡Listo! ¡prueba descargando la app en tu dispositivo!.</Text>
        <TouchableOpacity
          style={styles.buttonText}
          onPress={() => {
            setDone(false);
            setIndex(0);
            navigation.navigate(routes.FEED_SCREEN);
          }}
        >
          <Text >Descargar App</Text>
          <FontAwesome name="cloud-download" size={24} color="green" />
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={[styles.container, { backgroundColor: slide.color }]}>
      <StatusBar style="light" />
        <View style={styles.contentBackButtons}>
            <TouchableOpacity style={styles.skipBack} onPress={skipBack}>
              <Ionicons name="arrow-back" size={24} color="white"/>
              
              <Text style={styles.skipText}>Regresar</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.skip} onPress={skip}>       
              <Text style={styles.skipText}>Omitir</Text>
            </TouchableOpacity>
         </View>
      <View style={styles.content}>
        {slide.icon === 'Dichapp' ? (        
            <Image style={styles.image} source={require("../assets/fixdplanet1024.png")} />      
        ) :
        slide.icon === 'seedling' ? (
            <FontAwesome5 name={slide.icon} size={80} color={colors.white} style={{ marginBottom: 20 }} />
        )
        : (
          <Text style={styles.icon}>{slide.icon}</Text>
        )}
        <Text style={styles.title}>{slide.title}</Text>
        <Text style={styles.description}>{slide.description}</Text>
      </View>

      <View style={styles.footer}>
        <View style={styles.dots}>
          {SLIDES.map((_, i) => (
            <View
              key={i}
              style={[styles.dot, i === index && styles.dotActive]}
            />
          ))}
        </View>

        <Button
          title={isLast ? 'Comenzar' : 'Siguiente'}
          btnStyle={styles.button}
          color="white"
          onPress={next}
          txtStyle={{ color: colors.green, fontSize: textStyles.textBase, fontWeight: textStyles.fontWeightLarge }}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  contentBackButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  skip: { alignSelf: 'flex-end', padding: 20 },
  skipBack: { alignSelf: 'flex-start', padding: 20, flexDirection: 'row', alignItems: 'center' },
  skipText: {
    color: colors.white,
    fontSize: textStyles.textXSmall,
    opacity: 0.9,
    fontFamily: defaultStyles.text.fontFamily,
  },
  image: {
    borderRadius: 45,
    width: 80,
    height: 80,
    marginBottom: 20,
  },
  content: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
  },
  icon: { fontSize: 80, marginBottom: 20 },
  title: {
    fontSize: textStyles.textXl,
    fontWeight: '700',
    color: colors.white,
    textAlign: 'center',
    marginBottom: 12,
    fontFamily: defaultStyles.text.fontFamily,
  },
  description: {
    fontSize: textStyles.textLarge,
    color: colors.whiteAlpha90,
    textAlign: 'center',
    lineHeight: textStyles.lineHeightBase,
    maxWidth: 400,
    fontFamily: defaultStyles.text.fontFamily,
  },
  footer: { paddingHorizontal: 32, 
    paddingBottom: 48,
    //justifyContent: 'center',
    //alignSelf: 'center'
 },
  dots: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 24,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: colors.whiteAlpha40,
    marginHorizontal: 4,
  },
  dotActive: { width: 24, backgroundColor: colors.white },
  button: {
    //width: '80%',
    backgroundColor: colors.white,
    paddingVertical: 16,
    borderRadius: 30,
    alignItems: 'center',
  },
  buttonText: {
    borderRadius: 30,
    backgroundColor: colors.white,
    alignContent: 'center',
    textAlign: 'center',
    width: '100%',
    height: 50,
    color: colors.casiNegro,
    fontSize: textStyles.textBase,
    fontWeight: textStyles.fontWeightLarge,
    fontFamily: defaultStyles.text.fontFamily,
  },
  doneContainer: {
    flex: 1,
    backgroundColor: colors.green,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 24,
    padding: 32,
  },
  doneText: {
    color: colors.white,
    fontSize: textStyles.textMedium,
    textAlign: 'center',
    fontFamily: defaultStyles.text.fontFamily,
  },
});